<template>
	<div>
		<HeaderBar title="不良事件"></HeaderBar>
		<div class="center-box-no-footer">
			<van-form :model="form" ref="form">
				<van-cell-group title="不良事件名称（诊断/症状）">
					<FormNormalInput label="事件名称" v-model="form.bq422.Bq422_002" readonly />
				</van-cell-group>
				<van-cell-group title="治疗时间">
					<van-row>
						<FormNormalInput label="发生阶段" v-model="form.bq422.Bq422_003" readonly />
						<van-row v-show="form.bq422.Bq422_003 != ''">
							<van-col span="10">
								<FormNormalInput :label="form.bq422.Bq422_003" v-model="form.bq422.Bq422_00302"
									readonly />
							</van-col>
							<van-col span="14" class="unit">周</van-col>
						</van-row>
					</van-row>

				</van-cell-group>
				<van-cell-group title="严重程度">
					<van-row>
						<FormNormalInput label="严重程度" v-model="form.bq422.Bq422_004" readonly />
					</van-row>
				</van-cell-group>
				<van-cell-group title="与治疗药物因果关系">
					<van-row>
						<FormNormalInput label="因果关系" v-model="form.bq422.Bq422_005" readonly />
					</van-row>
				</van-cell-group>

				<van-cell-group title="不良事件结局">
					<van-row>
						<FormNormalInput label="结局" v-model="form.bq422.Bq422_006" readonly />
					</van-row>
				</van-cell-group>
				<van-cell-group title="不良事件持续时间">
					<van-row>
						<van-col span="10">
							<FormNormalInput label="持续时间" v-model="form.bq422.Bq422_007" readonly />
						</van-col>
						<van-col span="14" class="unit">周</van-col>
					</van-row>
				</van-cell-group>

				<van-cell-group title="是否因不良事件停用治疗药物">
					<van-row>
						<FormNormalInput label="停用治疗药物" v-model="form.bq422.Bq422_008" readonly />
					</van-row>
				</van-cell-group>
				<FormNormalUpload label="证明文件" ref="normalUpload" :infoGuid='form.bq422.guid' disabled>
				</FormNormalUpload>

			</van-form>
		</div>
	</div>
</template>


<script>
// import bus from '../bq400/page/js/eventBus.js'
export default {
	name: 's400Bq422Form',
	data() {
		return {
			form: {
				bq422: {
					id: "0", //编号
					guid: this.guid, //guid编号
					companyGuid: "", //单位编号
					departmentGuid: "", //部门编号
					checkStatus: "", //审核状态
					dataStatus: "", //数据状态
					addUid: "", //添加人编号
					addTime: "", //添加时间

					Bq001_018: this.bq001008, //患者编号
					Bq422_002: '', //事件名称
					Bq422_003: '', //
					Bq422_00302: '', //
					Bq422_004: '', //
					Bq422_005: '', //
					Bq422_006: '', //
					Bq422_007: '', //
					Bq422_008: '', //

				},
				sempFiles: [],
			},
			//发生时间
			createTime: [{ id: '治疗', name: '治疗' }, { id: '停药后', name: '停药后' },],
			//严重程度，5级
			severityLevels: [{ id: '1级', name: '1级' }, { id: '2级', name: '2级' }, { id: '3级', name: '3级' }, { id: '4级', name: '4级' }, { id: '5级', name: '5级' }],
			//与治疗药物因果关系
			drugRelationshipOptions: [{ id: '肯定有关', name: '肯定有关' }, { id: '很可能有关', name: '很可能有关' }, { id: '可能有关', name: '可能有关' }, { id: '可能无关', name: '可能无关' }, { id: '待评价', name: '待评价' }, { id: '无法评价', name: '无法评价' }],
			//不良事件结局
			eventOutcomeList: [{ id: '痊愈', name: '痊愈' }, { id: '部分缓解', name: '部分缓解' }, { id: '仍存在', name: '仍存在' }],
			//是否停用治疗药物
			drugStopOptions: [{ id: '是', name: '是' }, { id: '否', name: '否' }],
			fullscreenLoading: false,
			//保存接口
			saveUrl: this.$utils.Url.s400 + '/api/S400Bq422/Save',
			savestate: false,
			//bq400: JSON.parse(sessionStorage.getItem('bq400'))
		}

	},
	methods: {
		//加载信息
		LoadInfo: function () {
			var that = this
			var args = {
				guid: this.form.bq422.guid
			}
			that.$utils.HttpPost(this.$utils.Url.s400 + '/api/S400Bq422/Info', args, function (d) {
				that.form.bq422 = d.data
			}, null, null, null);
		},


	}, props: {
		guid: {
			type: String
		},
		disabled: {
			type: Boolean
		}
	},
	mounted() {
		this.LoadInfo()
	}
}
</script>

<style scoped>
.followRecord-title {
	padding-right: 10px;
}

.followRecord-tag {
	margin-right: 10px;
}

.unit {
	padding-top: 0.5rem;
	color: #999;
	font-size: 0.9em;
}
</style>
